var tl;

$(window).on('load',function(){
    tl = new TimelineMax()
		.timeScale(0.8)
		.fromTo(".navbar", 0.4, {opacity:0},{opacity:1, ease: Power2.easeOut},'-=0.15')
		.fromTo(".section-intro", 0.4, {opacity:0},{opacity:1, ease: Power2.easeOut},'-=0.15')
		.fromTo(".section-intro-logo", 0.4, {opacity:0, y:'-10%'},{opacity:1, y:'0%', ease: Power2.easeOut},'-=0.25')
        .fromTo(".section-intro-bottle", 0.7, {opacity:1, y:'-100%'},{opacity:1, y:'0%', ease: Power2.easeIn},'-=0.65')
		.fromTo(".section-intro-front, .section-intro-back", 0.1, {opacity:0},{opacity:1})
		.fromTo(".section-intro-front", 0.55, {scale:0.2, y:'20%'},{scale:1, y:'0%', ease: Power1.easeOut},'-=0.1')
        .fromTo(".section-intro-back", 0.55, {scale:0.2, y:'20%'},{scale:1, y:'0%', ease: Power1.easeOut},'-=0.55')
		.fromTo(".section-intro-buttons", 0.3, {opacity:0, y:'-10%'},{opacity:1, y:'0%', ease: Power2.easeOut});
});

$(document).ready(function(){
	var game = 3, stats, gameTS;
  	var foods = ['Salata Grecească', 'Quesadilla cu pui','Cotletul de porc','Copănelele la cuptor','Păstrăvul file la cuptor','Aripioarele de pui la cuptor'];
  
  function switchFood(food) {
    game = game - 1;
    
    $('.section-game-overlay-content').addClass('hidden');
    $('#gameOverlayFood').removeClass('hidden');
    $('#gameOverlayFoodImage').attr('src','/themes/oamenisigusturi/img/ingredientele-star/game-food-'+food+'.png');
    
    stats.push({
	    label: foods[food],
	    time: (new Date()).getTime() - gameTS.getTime()
    });
    
    if (food < 3) {
    	var ingredient = 'Staropramen Blondă';
    } else {
		var ingredient = 'Staropramen Nefiltrată';
	}
    
    if (game == 2) {
      var foodNext = 'Mai ai încă două preparate de găsit!';
    } else if (game == 1) {
      var foodNext = 'Mai ai încă un preparat de găsit!';
    } else {
      var foodNext = 'Ai găsit toate cele 3 preparate!';
    }
    
    var foodContent = '<h3>Bravo!</h3><p><strong>'+foods[food]+'</strong> se potrivește excelent cu <strong>Ingredientul - Star '+ingredient+'!</strong><br>'+foodNext+'</p><p><a role="button" class="btn btn-yellow btn-next">CONTINUĂ</a></p>';
	$('.close-next').show();
    $('#gameOverlayFoodContent').html(foodContent);
    
    $('.section-game-overlay').fadeIn();
  }
  
	$('.buton-verde').on('click', function(){
		scrollTo('.section-blonda', -50);
	});

	$('.buton-rosu').on('click', function(){
		scrollTo('.section-game', -50);
	});
	
	if(!$('form.modal-box').length) {
    $('#gameOverlayCongrats').removeClass('hidden');
  }

	$('.section-game-plate').on('click', function(){
		$(this).fadeOut();
		switchFood($(this).data('food'));
	});
  
	$('#gameStart').on('click', function(){
		stats = [];
		gameTS = new Date();
		(window.dataLayer || []).push({ 'event': 'isstartjoc2018' });

		$('#overlayBody').addClass('hidden');
		$('#overlayPrizes').removeClass('hidden');

		$('.close-prizes').show();
		//$('.section-game-overlay').fadeOut();
	});

	$('#gamePrizes, .close-prizes').on('click', function(){
		$('.section-game-overlay').fadeOut({complete:function(){
			$('#overlayBody').removeClass('hidden');
			$('#overlayPrizes').addClass('hidden');
			$('.close-prizes').hide();
		}});
	});
  
	$(document).on('click', '.btn-next, .close-next', function(){
		$('.section-game-overlay').fadeOut({complete:function(){
			if (game == 0) {
				$('input[name=game_log]').val(JSON.stringify(stats));
				$('.section-game-overlay-content').addClass('hidden');
				if ($('#gameOverlayForm').length) {
					$('#gameOverlayForm').removeClass('hidden');
				} else {
					$('form.modal-box').trigger('submit');
				}
				$('.section-game-overlay-close').hide();
				$('.section-game-overlay').fadeIn();
			}
		}});
	});
  
  $(document).on('submit', 'form.modal-box', function(e){
  	e.preventDefault();
    if($(this).data('submitting'))
      return false; //double submit
    $('.form-group', this).removeClass('has-error');
    $('.form-group span.help-block', this).remove();
    $(this).data('submitting', true).addClass('submitting');
    $('button[type=submit] span.submit-label', this).text('Se trimite...');
  
    $.ajax({
      type: $(this).attr('method'),
      url: $(this).attr('action'),
      data: $(this).serialize(),
      context: this,
//			dataType: 'json',
      success: function(data){
        $(this).data('submitting', false).removeClass('submitting');
        // $('*[name=receipt_store],input[name=receipt_id],input[name=receipt_date]', this).val('');
        $('*[name=code],input[name=receipt_id],input[name=receipt_date]', this).val(null);
        $('*[name=receipt_store]').val(null).trigger('change');
      
        (window.dataLayer || []).push({ 'event': 'issuccesjoc2018' });
        if (window.ga) {
          ga('send', 'pageview', '/ingredientele-star/success');
        }
        
        if(data.status === 'no_phone') {
          //todo optional: add CTA to complete profile to final message
        }
        $('#gameOverlayForm').addClass('hidden');
        $('#gameOverlayCongrats').removeClass('hidden');
      },
      error: function(xhr) {
        $(this).data('submitting', false).removeClass('submitting');
        $('button[type=submit] span.submit-label', this).text('Trimite');
        if(xhr.status == 422) {
          for(var field in xhr.responseJSON) {
            //console.log(field);
            $('*:not(.select2)[name='+field+'], input[name='+field+']+label', this)
                .last()
                .after(
                    function(){
                      $errors = "";
                      for(var err in xhr.responseJSON[field])
                        $errors += '<span class="help-block">'+xhr.responseJSON[field][err]+'</span>';
                      return $errors;
                    }
                )
                .parents('.form-group:first').addClass('has-error');
            $('*.select2[name='+field+']').next().after(
                function(){
                  $errors = "";
                  for(var err in xhr.responseJSON[field])
                    $errors += '<span class="help-block">'+xhr.responseJSON[field][err]+'</span>';
                  return $errors;
                }
            ).parents('.form-group:first').addClass('has-error');
          }
        } else if(xhr.status == 403) {
          console.log(xhr);
        }
      }
    });
  });

    //scroll animations
    var controller = new ScrollMagic.Controller();

    var scene = new ScrollMagic.Scene({
            triggerElement: ".section-blonda", duration: 0, offset: 0
        })
        .setTween(
            new TimelineMax()
			.fromTo(".section-blonda", 0.3, {opacity: 0}, {opacity:1, ease: Power2.easeOut})
            .fromTo(".section-blonda .section-plate-bottle", 0.5, {y:'-50%', opacity: 0}, {y:'0%',opacity:1, ease: Power2.easeOut})
			.fromTo(".section-blonda .section-plate-dish", 0.5, {x:'50%', opacity: 0}, {x:'0%',opacity:1, ease: Power2.easeOut})
			.fromTo(".section-blonda .section-plate-play", 0.3, {opacity: 0}, {opacity:1, ease: Power2.easeOut})
			.fromTo(".section-blonda .section-plate-copy", 0.3, {opacity: 0}, {opacity:1, ease: Power2.easeOut})
        )
        .addTo(controller);

    var scene = new ScrollMagic.Scene({
            triggerElement: ".section-nefiltrata", duration: 0, offset: 0
        })
        .setTween(
            new TimelineMax()
			.fromTo(".section-nefiltrata", 0.3, {opacity: 0}, {opacity:1, ease: Power2.easeOut})
            .fromTo(".section-nefiltrata .section-plate-bottle", 0.5, {y:'-50%', opacity: 0}, {y:'0%',opacity:1, ease: Power2.easeOut})
			.fromTo(".section-nefiltrata .section-plate-dish", 0.5, {x:'50%', opacity: 0}, {x:'0%',opacity:1, ease: Power2.easeOut})
			.fromTo(".section-nefiltrata .section-plate-play", 0.3, {opacity: 0}, {opacity:1, ease: Power2.easeOut})
			.fromTo(".section-nefiltrata .section-plate-copy", 0.3, {opacity: 0}, {opacity:1, ease: Power2.easeOut})
        )
        .addTo(controller);

});
